import React from 'react';
import logo from '../../assets/logo/VJ-College-logo.png';
import './Preloader.css';

export default function Preloader(props) {
  const { show } = props;

  if (!show) return null;

  return (
    <div className="preloader bg-soft flex-column justify-content-center align-items-center">
      <img className="loader-element animate__animated animate__jackInTheBox" src={logo} height={180} alt="Loading" />
    </div>
  );
}
